import * as React from 'react'
interface ContextType {
  iStage: number,
  iDay: number,
  current: number,
  iArea: number,
  lPid: number
}
const Default: ContextType = {
  iStage: 0,
  iDay: 0,
  current: 0,
  iArea: 0,
  lPid: 0
}
const Basics = React.createContext(Default);

export {
  Default,
  Basics,
}